// src/components/modals/DeleteTaskMoal.tsx
import React from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import { Modal } from "@/components/common/Modal";
import { Button } from "@/components/common/Button";
import { Input } from "@/components/common/Input";
import { Select } from "@/components/common/Select";
import { useUserStore } from "@/store/userStore";
import { USER_ROLES, USER_STATUS } from "@/utils/constants";
import { useTaskStore } from "@/store";
import { Task } from "@/types";

const userSchema = z.object({
  name: z.string().min(1, "User name is required"),
  email: z.string().email("Invalid email address"),
  password: z.string().min(8, "Password must be at least 8 characters"),
  role: z.enum([USER_ROLES.ADMIN, USER_ROLES.TEAM_MEMBER]),
});

type UserFormData = z.infer<typeof userSchema>;

interface DeleteTaskMoalProps {
  isOpen: boolean;
  onClose: () => void;
 task: Task;
}

export const DeleteTaskModal: React.FC<DeleteTaskMoalProps> = ({
  isOpen,
  onClose,
  task,
}) => {
  const { createUser } = useUserStore();
    const {deleteTask} = useTaskStore()

  const onSubmit = async () => {
    try {
      await deleteTask(task._id);
      onClose();
    } catch (error) {
      // Error is handled in the store
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Delete Task">
      <div className="flex justify-end space-x-3 pt-4 px-3">
        <p>Are You sure you want to delete this task ?</p>
        <Button
          variant="secondary"
          type="button"
          onClick={onClose}
          className="py-2"
        //   disabled={isSubmitting}
        >
          No
        </Button>
        <Button
          variant="danger"
          type="submit"         
          onClick={onSubmit}
        >
          Yes
        </Button>
      </div>
    </Modal>
  );
};
